module.exports = __webpack_public_path__ + "assets/img/behaviorfeature.d2ff6233.svg";